export type Lang = "en" | "ru";

type Dict = Record<string, string>;

const base: Record<Lang, Dict> = {
  en: {
    title: "SplitwiseKiller",
    activity: "Activity",
    account: "Account",
    accountSettings: "Account settings",
    buildInfo: "Build info",
    buildVersion: "Version",
    buildCommit: "Commit",
    buildTime: "Built at",
    theme: "Theme",
    dark: "Dark",
    light: "Light",
    youAreAllSettledUp: "You are all settled up!",
    recentActivityTitle: "Recent activity",
    settledUp: "settled up",
    youOwe: "you owe",
    youAreOwed: "you are owed",
    loading: "Loading…",
    refresh: "Refresh",
    groupId: "Group id",
    role: "role",
    paidBy: "paid by",
    createdBy: "Created by",
    updatedBy: "Updated by",
    deleted: "(deleted)",
    noteLabel: "note",
    select: "(select)",
    prefShort: "Pref",
    debtDisabled: "(debt simplification disabled)",
    remainingToAssign: "Remaining to assign",
    profileHeading: "Profile & Preferences",
    language: "Language",
    preferredCurrency: "Preferred currency",
    displayName: "Display name",
    saveProfile: "Save profile",
    changePassword: "Change password",
    currentPassword: "Current password",
    newPassword: "New password",
    removeAvatar: "Remove avatar",
    profile: "Profile",
    signedInAs: "Signed in as",
    admin: "(admin)",
    createInvite: "Create invite",
    inviteHelp: "Create a registration link and send it to someone you want to invite.",
    copy: "Copy",
    copied: "Copied",
    openMail: "Open mail",
    refreshGroups: "Refresh groups",
    refreshFriends: "Refresh friends",
    refreshContacts: "Refresh contacts",
    logout: "Log out",
    inviteToken: "invite token",
    inviteUrl: "invite url",
    groups: "Groups",
    name: "Name",
    currency: "Currency",
    avatar: "Avatar",
    avatarReady: "Avatar uploaded",
    addMembers: "Add participants (friends or past group mates)",
    phone: "Phone",
    localDisplayName: "Display name (for you)",
    pendingRegistration: "pending",
    contactHint: "Email or phone is required",
    contactExists: "Contact already exists for this email/phone",
    cannotDeleteContactBalance: "Cannot delete contact with non-zero balance",
    leaveGroup: "Leave group",
    leaveGroupConfirm: "Leave this group?",
    cannotLeaveGroupBalance: "Cannot leave group with non-zero balance",
    noContacts: "No contacts yet",
    createGroup: "Create group",
    friends: "Friends",
    contactsLabel: "Contacts",
    search: "Search",
    friendEmail: "Friend email",
    addFriend: "Add friend",
    open: "Open",
    openLedger: "Open ledger",
    login: "Login",
    register: "Register",
    joinGroup: "Join group",
    email: "Email",
    password: "Password",
    enterEmail: "Enter email",
    enterPassword: "Enter password",
    passwordMin: "Password (min 8 chars)",
    inviteTokenLabel: "Invite token",
    groupInviteToken: "Group invite token",
    loginFirst: "Login first to join a group.",
    back: "Back",
    createGroupInvite: "Create group invite",
    invites: "Invites",
    revoke: "Revoke",
    revoked: "revoked",
    used: "used",
    active: "active",
    inviteAlreadyUsed: "Invite already used",
    exportCsv: "Export CSV",
    addExpense: "Add expense",
    addSettlement: "Add settlement",
    joinUrl: "Join URL",
    editGroup: "Edit group",
    groupDetails: "Group details",
    saveChanges: "Save changes",
    includeDeleted: "Show deleted",
    members: "Members",
    addMember: "Add member",
    fromContacts: "From contacts",
    byEmail: "By email",
    noEligibleContacts: "No eligible contacts",
    displayNameOptional: "Display name (optional)",
    placeholderHint: "If the user doesn't exist yet, a placeholder will be created so you can split expenses.",
    add: "Add",
    saving: "Saving…",
    close: "Close",
    removeMember: "Remove member",
    cannotRemoveMemberBalance: "Cannot remove member with non-zero balance",
    cannotRemoveLastAdmin: "Cannot remove last admin",
    useLeaveEndpoint: "Use leave instead",
    none: "(none)",
    newExpense: "New expense",
    editExpense: "Edit expense",
    description: "Description",
    amount: "Amount",
    when: "When",
    category: "Category",
    note: "Note",
    payers: "Payers (sum must equal amount)",
    autoForEqualSplit: "Auto for equal split",
    autoForEqualPayers: "For equal split: select who paid; amount is split between selected payers",
    splitType: "Split type",
    equal: "Equal",
    exact: "Exact",
    percent: "Percent",
    shares: "Shares",
    participants: "Participants",
    selectAtLeastOneParticipant: "Select at least one participant",
    selectAtLeastOnePayer: "Select at least one payer",
    exactAmounts: "Exact amounts (sum must equal amount)",
    percentSum: "Percent (sum must equal 100.00)",
    sharesSum: "Shares (sum must be > 0)",
    create: "Create",
    save: "Save",
    cancel: "Cancel",
    newSettlement: "New settlement",
    from: "From",
    to: "To",
    balances: "Balances",
    simplifiedTransfers: "Simplified transfers",
    disabled: "(disabled)",
    expenses: "Expenses",
    delete: "Delete",
    restore: "Restore",
    expenseDetails: "Expense details",
    splits: "Splits",
    attachments: "Attachments",
    comments: "Comments",
    writeComment: "Write a comment…",
    addComment: "Add comment",
    edit: "Edit",
    settlements: "Settlements",
    participantsNone: "No members",
  },
  ru: {
    title: "SplitwiseKiller",
    activity: "Активность",
    account: "Аккаунт",
    accountSettings: "Настройки аккаунта",
    buildInfo: "Информация о сборке",
    buildVersion: "Версия",
    buildCommit: "Коммит",
    buildTime: "Собрано",
    theme: "Тема",
    dark: "Тёмная",
    light: "Светлая",
    youAreAllSettledUp: "Вы все рассчитались!",
    recentActivityTitle: "Последняя активность",
    settledUp: "рассчитались",
    youOwe: "вы должны",
    youAreOwed: "вам должны",
    loading: "Загрузка…",
    refresh: "Обновить",
    groupId: "ID группы",
    role: "роль",
    paidBy: "оплатил",
    createdBy: "Создал",
    updatedBy: "Обновил",
    deleted: "(удалено)",
    noteLabel: "заметка",
    select: "(выбрать)",
    prefShort: "Профиль",
    debtDisabled: "(упрощение долгов выключено)",
    remainingToAssign: "Осталось распределить",
    profileHeading: "Профиль и настройки",
    language: "Язык",
    preferredCurrency: "Предпочтительная валюта",
    displayName: "Отображаемое имя",
    saveProfile: "Сохранить профиль",
    changePassword: "Сменить пароль",
    currentPassword: "Текущий пароль",
    newPassword: "Новый пароль",
    removeAvatar: "Удалить аватар",
    profile: "Профиль",
    signedInAs: "Вы вошли как",
    admin: "(админ)",
    createInvite: "Создать инвайт",
    inviteHelp: "Создайте ссылку для регистрации и отправьте ее человеку, которого хотите пригласить.",
    copy: "Скопировать",
    copied: "Скопировано",
    openMail: "Открыть почту",
    refreshGroups: "Обновить группы",
    refreshFriends: "Обновить друзей",
    refreshContacts: "Обновить контакты",
    logout: "Выйти",
    inviteToken: "инвайт-токен",
    inviteUrl: "ссылка для приглашения",
    groups: "Группы",
    name: "Название",
    currency: "Валюта",
    avatar: "Аватар",
    avatarReady: "Аватар загружен",
    addMembers: "Добавить участников (друзья или участники ваших групп)",
    phone: "Телефон",
    localDisplayName: "Отображаемое имя (для вас)",
    pendingRegistration: "ожидает регистрации",
    contactHint: "Нужен email или телефон",
    contactExists: "Контакт с этим email/телефоном уже существует",
    cannotDeleteContactBalance: "Нельзя удалить контакт с ненулевым балансом",
    leaveGroup: "Выйти из группы",
    leaveGroupConfirm: "Выйти из группы?",
    cannotLeaveGroupBalance: "Нельзя выйти из группы с ненулевым балансом",
    noContacts: "Нет доступных контактов",
    createGroup: "Создать группу",
    friends: "Друзья",
    contactsLabel: "Контакты",
    search: "Поиск",
    friendEmail: "Email друга",
    addFriend: "Добавить друга",
    open: "Открыть",
    openLedger: "Открыть расчёты",
    login: "Войти",
    register: "Регистрация",
    joinGroup: "Присоединиться",
    email: "Email",
    password: "Пароль",
    enterEmail: "Введите e-mail",
    enterPassword: "Введите пароль",
    passwordMin: "Пароль (мин 8 символов)",
    inviteTokenLabel: "Инвайт-токен",
    groupInviteToken: "Токен приглашения в группу",
    loginFirst: "Сначала войдите, чтобы присоединиться к группе.",
    back: "Назад",
    createGroupInvite: "Создать приглашение в группу",
    invites: "Приглашения",
    revoke: "Отозвать",
    revoked: "отозвано",
    used: "использовано",
    active: "активно",
    inviteAlreadyUsed: "Приглашение уже использовано",
    exportCsv: "Экспорт CSV",
    addExpense: "Добавить расход",
    addSettlement: "Добавить перевод",
    joinUrl: "Ссылка для входа",
    editGroup: "Редактировать группу",
    groupDetails: "Настройки группы",
    saveChanges: "Сохранить изменения",
    includeDeleted: "Показать удалённые",
    members: "Участники",
    addMember: "Добавить участника",
    fromContacts: "Из контактов",
    byEmail: "По email",
    noEligibleContacts: "Нет подходящих контактов",
    displayNameOptional: "Имя (опционально)",
    placeholderHint: "Если пользователя еще нет, будет создан placeholder, чтобы можно было делить расходы.",
    add: "Добавить",
    saving: "Сохранение…",
    close: "Закрыть",
    removeMember: "Удалить участника",
    cannotRemoveMemberBalance: "Нельзя удалить участника с ненулевым балансом",
    cannotRemoveLastAdmin: "Нельзя удалить последнего администратора",
    useLeaveEndpoint: "Для себя используйте «Выйти»",
    none: "(нет)",
    newExpense: "Новый расход",
    editExpense: "Редактировать расход",
    description: "Описание",
    amount: "Сумма",
    when: "Когда",
    category: "Категория",
    note: "Заметка",
    payers: "Плательщики (сумма должна совпадать)",
    autoForEqualSplit: "Автоматически для делёжки поровну",
    autoForEqualPayers: "Для «поровну»: отметьте, кто платил; сумма разделится между отмеченными плательщиками",
    splitType: "Тип делёжки",
    equal: "Поровну",
    exact: "Точно",
    percent: "Проценты",
    shares: "Доли",
    participants: "Участники",
    selectAtLeastOneParticipant: "Выберите хотя бы одного участника",
    selectAtLeastOnePayer: "Выберите хотя бы одного плательщика",
    exactAmounts: "Точные суммы (должны совпасть)",
    percentSum: "Проценты (должны дать 100.00)",
    sharesSum: "Доли (сумма > 0)",
    create: "Создать",
    save: "Сохранить",
    cancel: "Отмена",
    newSettlement: "Новый перевод",
    from: "От",
    to: "Кому",
    balances: "Балансы",
    simplifiedTransfers: "Упрощённые переводы",
    disabled: "(выключено)",
    expenses: "Расходы",
    delete: "Удалить",
    restore: "Восстановить",
    expenseDetails: "Детали расхода",
    splits: "Доли",
    attachments: "Вложения",
    comments: "Комментарии",
    writeComment: "Напишите комментарий…",
    addComment: "Добавить комментарий",
    edit: "Редактировать",
    settlements: "Переводы",
    participantsNone: "Нет участников",
  },
};

export function t(lang: Lang, key: keyof typeof base.en): string {
  return base[lang]?.[key] ?? base.en[key] ?? key;
}
